// src/emotions.js
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  DeleteButton,
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  Edit,
} from "react-admin";

// ✅ List emotions in a clean table
export const EmotionList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="type" />
      <TextField source="EMQmomentum" label="EMQ Momentum" />
      <TextField source="EMQformation" label="EMQ Formation" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

// ✅ Create new emotions
export const EmotionCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      {/* Name */}
      <TextInput source="name" label="Name" />

      {/* Type */}
      <SelectInput
        source="type"
        label="Type"
        choices={[
          { id: "basic", name: "Basic" },
          { id: "advanced", name: "Advanced" },
        ]}
      />

      {/* EMQ Momentum → pulls from momentums collection */}
      <ReferenceInput source="EMQmomentum" reference="momentums" label="EMQ Momentum">
        <SelectInput optionText="name" />
      </ReferenceInput>

      {/* EMQ Formation → pulls from formations collection */}
      <ReferenceInput source="EMQformation" reference="formations" label="EMQ Formation">
        <SelectInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

// ✅ Edit existing emotions
export const EmotionEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" label="Name" />
      <SelectInput
        source="type"
        label="Type"
        choices={[
          { id: "basic", name: "Basic" },
          { id: "advanced", name: "Advanced" },
        ]}
      />
      <ReferenceInput source="EMQmomentum" reference="momentums" label="EMQ Momentum">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput source="EMQformation" reference="formations" label="EMQ Formation">
        <SelectInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
